import React from "react";

interface DefaultAvatarProps {
  name?: string;
  size?: "sm" | "md" | "lg" | "xl" | "2xl";
  type?: "COMPANY" | "CONTACT" | "SALE" | "TASK";
  className?: string;
  iconSize?: "sm" | "md" | "lg" | "xl" | "2xl" | "3xl" | "4xl" | "5xl";
}

const DefaultAvatar: React.FC<DefaultAvatarProps> = ({
  name = "",
  size = "md",
  iconSize = "md",
  type = "COMPANY",
  className = "",
}) => {
  const getInitials = (name: string) => {
    if (!name) return "?";
    const words = name.trim().split(" ");
    if (words.length === 1) {
      return words[0].charAt(0).toUpperCase();
    }
    return (words[0].charAt(0) + words[words.length - 1].charAt(0)).toUpperCase();
  };

  const getSizeClasses = () => {
    switch (size) {
      case "sm":
        return "w-5 h-5 text-xs";
      case "lg":
        return "w-12 h-12 text-lg";
      case "xl":
        return "w-16 h-16 text-xl";
      case "2xl":
        return "w-20 h-20 text-2xl";
      default:
        return "w-8 h-8 text-sm";
    }
  };

  const getIconSizeClasses = () => {
    switch (iconSize) {
      case "sm":
        return "text-xs";
      case "md":
        return "text-sm";
      case "lg":
        return "text-lg";
      case "xl":
        return "text-xl";
      case "2xl":
        return "text-2xl";
      case "3xl":
        return "text-3xl";
      case "4xl":
        return "text-4xl";
      case "5xl":
        return "text-5xl";
      default:
        return "text-sm";
    }
  };

  const getTypeIcon = () => {
    switch (type) {
      case "COMPANY":
        return "🏢";
      case "CONTACT":
        return "👤";
      case "SALE":
        return "💰";
      case "TASK":
        return "📋";
      default:
        return "📄";
    }
  };

  const initials = getInitials(name);
  const sizeClasses = getSizeClasses();
  const iconSizeClasses = getIconSizeClasses();

  return (
    <div
      className={`
        ${sizeClasses} 
        rounded-2xl 
        flex 
        items-center 
        justify-center 
        font-semibold 
        ${className}
      `}
      title={name || type}
    >
      {initials === "?" ? (
        <span className={`${iconSizeClasses}`}>{getTypeIcon()}</span>
      ) : (
        <span>{initials}</span>
      )}
    </div>
  );
};

export default DefaultAvatar;
